import { render, staticRenderFns } from "./rate-widget.vue?vue&type=template&id=2d7c5c3c&scoped=true"
import script from "./rate-widget.vue?vue&type=script&lang=js"
export * from "./rate-widget.vue?vue&type=script&lang=js"
import style0 from "./rate-widget.vue?vue&type=style&index=0&id=2d7c5c3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7c5c3c",
  null
  
)

export default component.exports